import { render, staticRenderFns } from "./UpdateAdmin.vue?vue&type=template&id=615f1b56&"
import script from "./UpdateAdmin.vue?vue&type=script&lang=js&"
export * from "./UpdateAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports